import React from 'react';
import { clsx } from 'clsx';
import Icon from './Icon';

interface ValidationError {
  message: string;
  path: string;
}

interface ValidationWarningProps {
  errors: ValidationError[];
  onDismiss?: () => void;
}

const ValidationWarning: React.FC<ValidationWarningProps> = ({
  errors,
  onDismiss,
}) => {
  if (errors.length === 0) {
    return null;
  }

  return (
    <div className="mb-4">
      <div
        className={clsx(
          'relative p-4 flex gap-2 items-start rounded-xl border shadow-sm',
          'text-error-d-700 border-error-d-300 bg-error-d-25',
        )}
      >
        <div className="absolute -translate-y-1/4">
          <IconWithRings />
        </div>

        <div className="text-sm space-y-1 pl-12 flex-1">
          <p className="font-semibold">Validation Errors:</p>
          <ul className="list-disc pl-4 space-y-1">
            {errors.map((error, index) => (
              <li key={index}>{error.message}</li>
            ))}
          </ul>
        </div>

        {onDismiss && (
          <button
            aria-label="Dismiss validation errors"
            className="text-error-d-600 hover:text-error-d-800 p-1"
            onClick={onDismiss}
          >
            <div className="w-4 h-4">
              <Icon id="x" />
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

const IconWithRings = () => {
  return (
    <div className="relative flex items-center justify-center w-9 h-9 text-error-d-600">
      {/* Outer ring */}
      <div className="absolute inset-0 w-9 h-9 border border-error-d-600 opacity-10 rounded-full" />
      {/* Inner ring */}
      <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 w-7 h-7 border border-error-d-600 opacity-30 rounded-full" />

      <div className="w-5 h-5">
        <Icon id="alert-circle" />
      </div>
    </div>
  );
};

export default ValidationWarning;
